import store from '../redux/store';
import { arrayToObjMap } from './utils';

store.subscribe(listener);

function hasSetting(setting) {
    return setting && setting.length;
}

function listener() {
    let state = store.getState();

    if (state.settings.updateTimestamp !== settingsUpdateTimestamp) {
        const { loading: loadingSettings, data: settings } = state.settings.systemSettings;
        settingsUpdateTimestamp = state.settings.updateTimestamp;
        LoadingSettings = loadingSettings;
        Settings = settings;

        if (!loadingSettings) {
            if (hasSetting(settings.otherSettings.departments)) Departments = arrayToObjMap(settings.otherSettings.departments);
            if (hasSetting(settings.otherSettings.permissionTypes)) PermissionTypes = arrayToObjMap(settings.otherSettings.permissionTypes, true);
            if (hasSetting(settings.otherSettings.applicationStatuses)) ApplicationStatuses = arrayToObjMap(settings.otherSettings.applicationStatuses);
            if (hasSetting(settings.otherSettings.recipientStatuses)) RecipientStatuses = arrayToObjMap(settings.otherSettings.recipientStatuses);
            if (hasSetting(settings.otherSettings.recipientTypes)) RecipientTypes = arrayToObjMap(settings.otherSettings.recipientTypes);
            if (hasSetting(settings.otherSettings.campaignListStatuses)) CampaignListStatuses = arrayToObjMap(settings.otherSettings.campaignListStatuses);
            if (hasSetting(settings.otherSettings.campaignCategorie)) CampaignCategoryTypes = arrayToObjMap(settings.otherSettings.campaignCategories);
            if (hasSetting(settings.otherSettings.campaignStatuses)) CampaignStatuses = arrayToObjMap(settings.otherSettings.campaignStatuses);
            if (hasSetting(settings.otherSettings.campaignListTypes)) CampaignListTypes = arrayToObjMap(settings.otherSettings.campaignListTypes);
            if (hasSetting(settings.otherSettings.orgEmploymentTypes)) OrgEmploymentTypes = arrayToObjMap(settings.otherSettings.orgEmploymentTypes, true);
            if (hasSetting(settings.otherSettings.previousEmploymentTypes)) PreviousEmploymentTypes = arrayToObjMap(settings.otherSettings.previousEmploymentTypes, true);
            if (hasSetting(settings.otherSettings.currencyTypes)) CurrencyTypes = arrayToObjMap(settings.otherSettings.currencyTypes);
        }
    }
}

var settingsUpdateTimestamp = null;
export var LoadingSettings = false;
export var Settings = {};

export var Departments = {
    US: 'US',
    IL: 'IL'
};

export var PermissionTypes = {
    ApplicationsView: 'ApplicationsView',
    ApplicationsManage: 'ApplicationsManage',
    ApplicationsApproveFull: 'ApplicationsApproveFull',
    ApplicationsApproveLimited: 'ApplicationsApproveLimited',
    ApplicationsPrivate: 'ApplicationsPrivate',
    RecipientAccntsView: 'RecipientAccntsView',
    RecipientAccntsManage: 'RecipientAccntsManage',
    CampaignAndListsView: 'CampaignAndListsView',
    CampaignAndListsManage: 'CampaignAndListsManage',
    PaymentsACH: 'PaymentsACH',
    PaymentsPrint: 'PaymentsPrint',
    PaymentsWire: 'PaymentsWire',
    PaymentsVoid: 'PaymentsVoid',
    AccountingView: 'AccountingView',
    AccountingManage: 'AccountingManage',
    Reporting: 'Reporting',
    UsersAndSettingsManage: 'UsersAndSettingsManage',
    IndividualsManage: 'IndividualsManage',
    InstitutionsManage: 'InstitutionsManage',
    AllFundsAccess: 'AllFundsAccess',
    LimitedFundsAccess: "LimitedFundsAccess"
};

export var ApplicationStatuses = {
    New: 'New',
    InReview: 'In Review',
    Incomplete: 'Incomplete',
    Approved: 'Approved',
    Paid: 'Paid',
    Rejected: 'Rejected'
};

export var RecipientStatuses = {
    New: 'New',
    HasBeenApproved: 'Has Been Approved',
    HasBeenRejected: 'Has Been Rejected'
};

export var RecipientTypes = {
    Organization: 'Organization',
    Individual: 'Individual'
};

export var CampaignListStatuses = {
    Added: 'Added',
    Approved: 'Approved',
    Sent: 'Sent',
    Submitted: 'Submitted'
};

export var CampaignCategoryTypes = {
    Yearly: 'Yearly',
    Monthly: 'Monthly'
};

export var CampaignStatuses = {
    Open: 'Open',
    Closed: 'Closed'
};

export var CampaignListTypes = {
    Internal: 'Internal',
    External: 'External'
};

export var OrgEmploymentTypes = {
    Rebbi: 'Rebbi',
    Other: 'Other',
    NA: 'NA'
};

export var PreviousEmploymentTypes = {
    Kollel: 'Kollel',
    Rebbi: 'Rebbi',
    Other: 'Other',
    NA: 'NA'
};

export var CurrencyTypes = {
    Dollar: '$',
    Shekel: '₪'
};

export const ManualPaymentTypes = {
    BlankCheck: 'BlankCheck',
    ManualCheck: 'ManualCheck',
    ManualWire: 'ManualWire'
}


// WEBPACK FOOTER //
// ./src/lib/systemVariables.js